/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit, AfterViewInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getRouteInitData, State } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { FocusedCell, GridComponent } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { HpeComponent } from '../../../resources/hpe-details.model';
import { HpeCommandService } from '../hpe-command.service';
import {
  HpeDetailsState,
  HpeFocusedTable,
  queryHpeComponents,
  queryHpeEditable,
  queryHpeFocusedCell,
  queryHpeSelectedComponentId,
} from '../hpe-details.state';
import { HpeDetailsComponentGridDefinition } from './hpe-details-component-grid-definition.service';

@Component({
  selector: 'gh-hpe-details-component-list',
  template: require('./hpe-details-component-list.component.html'),
  styles: [require('./hpe-details-component-list.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HpeDetailsComponentGridDefinition],
})
export class HpeDetailsComponentListComponent implements OnInit, AfterViewInit {
  @ViewChild('grid') grid: GridComponent;

  selectedComponentId$: Observable<Maybe<ID>>;
  components$: Observable<HpeComponent[]>;
  focusedCell$: Observable<Maybe<FocusedCell>>;
  editable: boolean = true;

  constructor(private route: ActivatedRoute,
              private state: State<HpeDetailsState>,
              private commands: HpeCommandService,
              public gridDefinition: HpeDetailsComponentGridDefinition,
              private cd: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    const { hpeComponentGridLayout } = getRouteInitData(this.route);

    this.gridDefinition.bind(hpeComponentGridLayout);

    this.components$ = this.state.select(queryHpeComponents);
    this.selectedComponentId$ = this.state.select(queryHpeSelectedComponentId);
    this.focusedCell$ = this.state.select(queryHpeFocusedCell, HpeFocusedTable.ComponentList);
    this.editable = this.state.project(queryHpeEditable);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.grid) {
        this.grid.api?.sizeColumnsToFit();
        window.dispatchEvent(new Event('resize'));
      }
      this.cd.detectChanges();
    });
  }

  onAdd(): void {
    this.commands.componentAdd();
  }

  onHpeCloneComponent(component: HpeComponent): void {
    this.commands.hpeComponentClone(component);
  }
  onDelete(component: HpeComponent): void {
    this.commands.componentRemove(component);
  }

  onSelectedComponentChanged(id?: ID): void {
    this.commands.componentSelect(id);
  }

  onFocusedCellChanged(): void {
    this.commands.resetFocusedCell();
  }
}
